import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import thisapp_en from "./locales/en.json"
import thisapp_tr from "./locales/tr.json"
import common_en from "../../../i18n/common/en.json"
import common_tr from "../../../i18n/common/tr.json"

const en = {translation: {...common_en.translation, ...thisapp_en.translation}}
const tr = {translation: {...common_tr.translation, ...thisapp_tr.translation}}
const getQueryStringValue = (paramName, defaultValue) => {
  const queryParams = new URLSearchParams(window.location.search)
  if (queryParams){
    let retVal:any = queryParams.get(paramName)
    if (retVal){
      return retVal
    }
    return defaultValue
  }
}

const defaultLng = "tr"
const lng = getQueryStringValue("l", defaultLng)

i18n.use(initReactI18next).init({
  resources: {
    en,
    tr
  },
  lng: (lng !== "tr" && lng !== "en" ? defaultLng : lng),
  interpolation: {
    escapeValue: false // react already safes from xss
  }
})

export default i18n
